import { usePageModels } from '@/context/PageModels';
import { BrPageContext } from '@bloomreach/react-sdk';
import React, { useContext } from 'react';
import SEOHrefLang from '../shared/SEOHrefLang';
import SEO from './SEO';

export const withMetadata = (Component: React.FC) => (props: any) => {
  const { config, httpStatusCode } = usePageModels();
  const page = useContext(BrPageContext);
  const component = page?.getComponent('metadata');
  const documentRef = component?.getModels().document;
  const { tags, metadataCompound, pageMetadata } =
    (documentRef && page?.getContent(documentRef)?.getData()) || {};
  const translationConfig = config?.translation;
  const metadata = React.useMemo(
    () => metadataCompound || pageMetadata || {},
    [metadataCompound, pageMetadata],
  );
  const hrefLangProps = React.useMemo(
    () => ({
      hrefLangsRaw: metadata?.hreflangUrl || null,
      exclusionPaths: translationConfig?.endpoint_exclusion_paths,
      countryCodesWhitelist: translationConfig?.country_codes_whitelist,
    }),
    [
      metadata?.hreflangUrl,
      translationConfig?.endpoint_exclusion_paths,
      translationConfig?.country_codes_whitelist,
    ],
  );

  // SEO and SEOHrefLang are only rendered if the metadata is given as "model" rather than "component".
  // AKA x-pages, e.g.: Portal pages.
  const hasMetaData = React.useMemo(() => !!Object.keys(metadata).length, [metadata]);
  const hasHrefLang = React.useMemo(() => !!Object.keys(hrefLangProps).length, [hrefLangProps]);

  return (
    <>
      <Component {...props} />
      {hasMetaData && (
        <SEO metadata={metadata} tags={tags} httpStatusCode={httpStatusCode} isDocumentBasedPage />
      )}
      {hasMetaData && hasHrefLang && <SEOHrefLang {...hrefLangProps} />}
    </>
  );
};
